import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__arrow",
  "use": "general__arrow-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" stroke-linecap=\"round\" stroke-width=\"2\" viewBox=\"0 0 12 13\" id=\"general__arrow\">\n  <path d=\"M6 1.5v10M1.5 6 6 1.5M6 1.5 10.5 6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol